<template>
  <div
    class="main"
    :style="{
      display: 'flex',
      width: '100%',
      backgroundImage: `url(${image})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: '100%',
    }"
  >
    <div class="language-select" @click.stop>
      <button class="language-select__toggle" type="button" @click="toggleLanguageMenu">
        <img
          class="language-select__flag"
          :src="selectedLanguageOption.flag"
          :alt="selectedLanguageOption.label"
        />
        <span>{{ selectedLanguageOption.shortLabel }}</span>
        <span class="language-select__chevron"></span>
      </button>
      <div v-if="isLanguageMenuOpen" class="language-select__menu">
        <button
          v-for="language in languageOptions"
          :key="language.value"
          class="language-select__option"
          :class="{ 'language-select__option--active': language.value === lang }"
          type="button"
          @click="changeLanguage(language.value)"
        >
          <img
            class="language-select__flag"
            :src="language.flag"
            :alt="language.label"
          />
          <span>{{ language.label }}</span>
        </button>
      </div>
    </div>
    <div id="meeyid-sdk-box" ref="sdkBox" class="box"></div>
  </div>
</template>

<script>
import image from "@/assets/images/bg.png";
import viFlag from "@/assets/svg/vi.svg";
import enFlag from "@/assets/svg/en.svg";

const SDK_LANG_STORAGE_KEY = "lang";
const SDK_LANGUAGES = ["vi", "en"];
const SDK_LANGUAGE_OPTIONS = [
  {
    value: "vi",
    label: "Tiếng Việt",
    shortLabel: "VI",
    flag: viFlag,
  },
  {
    value: "en",
    label: "English",
    shortLabel: "EN",
    flag: enFlag,
  },
];

export default {
  data() {
    return {
      image: image,
      lang: this.getStoredLanguage(),
      languageOptions: SDK_LANGUAGE_OPTIONS,
      isLanguageMenuOpen: false,
    };
  },
  computed: {
    selectedLanguageOption() {
      return (
        this.languageOptions.find((language) => language.value === this.lang) ||
        this.languageOptions[0]
      );
    },
  },
  watch: {},
  mounted() {
    if (!window.MeeyId) {
      // async init
      window.meeyIdAsyncInit = () => {
        this.initMeeyid(window.MeeyId, this.$route.params.page);
      };
    } else {
      this.initMeeyid(window.MeeyId, this.$route.params.page);
    }

    window.addEventListener("visibilitychange", () => {
      window.MeeyId.syncUser()
    });

    window.addEventListener("load", () => {
      window.MeeyId.syncUser()
    });

    window.addEventListener("focus", () => {
      window.MeeyId.syncUser();
    });
    document.addEventListener("click", this.closeLanguageMenu);
    window.$("input:visible:first").focus();
  },
  beforeDestroy() {
    document.removeEventListener("click", this.closeLanguageMenu);
  },
  methods: {
    getStoredLanguage() {
      const lang = window.localStorage.getItem(SDK_LANG_STORAGE_KEY);

      return SDK_LANGUAGES.includes(lang) ? lang : SDK_LANGUAGES[0];
    },
    toggleLanguageMenu() {
      this.isLanguageMenuOpen = !this.isLanguageMenuOpen;
    },
    closeLanguageMenu() {
      this.isLanguageMenuOpen = false;
    },
    changeLanguage(lang) {
      this.closeLanguageMenu();

      if (lang === this.lang) {
        return;
      }

      this.lang = lang;
      window.localStorage.setItem(SDK_LANG_STORAGE_KEY, this.lang);

      window.location.reload();
    },
    initMeeyid(MeeyId, route) {
      if (this.$refs.sdkBox) {
        this.$refs.sdkBox.innerHTML = "";
      }

      MeeyId.initSDK(null, {
        clientId: "meeyid",
        type: "form",
        divElement: "#meeyid-sdk-box",
        sso: true,
        route: route,
        lang: this.lang,
        onReady: () => {},
        onUser: async (user) => {
          console.trace("example.onUser -> user", user);
          if (user) {
            const _auth = user;
            window.localStorageX.setItem("_auth", JSON.stringify(_auth));
            console.log("FE-window.localStorageX", window.localStorageX);
            if (_auth.access_token && _auth.user) {
              try {
                // verify accessToken
                //await UserApi.me();
                document.cookie = `token=${_auth.access_token};max-age=${_auth.expires_in};path=/`;
                // save cookie
                location.href = `/userbackend/users/user-info?lang=${encodeURIComponent(this.lang)}`;
              } catch (e) {
                console.log("FE-error", e);
                window.localStorageX.removeItem("_auth");
              }
            }
          }
        },
        onSignInCompleted: () => {
          console.trace("onSignInCompleted");
        },
        onSignOutCompleted: () => {
          console.trace("onSignOutCompleted");
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  height: 100vh;
  position: relative;
}
.box {
  width: 450px;
  margin: auto;
}
.language-select {
  position: absolute;
  top: 24px;
  right: 24px;
  z-index: 2;
}
.language-select__toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 92px;
  height: 40px;
  padding: 0 12px;
  border: 1px solid #dadada;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  color: #343434;
  font-weight: 600;
  cursor: pointer;
}
.language-select__flag {
  width: 24px;
  height: 18px;
  flex: 0 0 auto;
  border-radius: 3px;
  object-fit: cover;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.08);
}
.language-select__chevron {
  width: 8px;
  height: 8px;
  margin-left: auto;
  border-right: 2px solid #646464;
  border-bottom: 2px solid #646464;
  transform: rotate(45deg) translateY(-2px);
}
.language-select__menu {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  min-width: 150px;
  padding: 6px;
  border: 1px solid #e7e7e7;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 14px 32px rgba(0, 0, 0, 0.14);
}
.language-select__option {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  height: 38px;
  padding: 0 10px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #343434;
  font-weight: 500;
  text-align: left;
  cursor: pointer;
}
.language-select__option:hover,
.language-select__option--active {
  background: #f2f6ff;
  color: #275eca;
}

// MOBILE
@media screen and (max-width: 500px) {
  .main {
    //  height: 100vh;
    max-height: 100%;
  }
  .box {
    padding: 0;
    width: 100%;
    margin: 0;
    position: relative;
  }
  .language-select {
    top: 12px;
    right: 12px;
  }
}
</style>
